// qs-type-customImage.ts
export interface CustomImageProcessor {
  processImageFile(file: File): Promise<CustomImageData>
  validateFile(file: File): boolean
  scaleImage(image: HTMLImageElement): Promise<string>
  generatePreview(dataUrl: string): Promise<string>
}

export interface FileUploadHandler {
  openFileDialog(): Promise<File | null>
  handleFileSelection(file: File): Promise<void>
  removeCustomImage(): void
  isCustomImageActive(): boolean
}

export interface CustomImageData {
  id: string
  name: string
  dataUrl: string
  preview: string
  originalDimensions: { width: number; height: number }
  processedDimensions: { width: number; height: number }
  fileSize: number
  fileType: string
  createdAt: Date
}

export interface ImageProcessingOptions {
  maxWidth: number
  maxHeight: number
  quality: number
  format: 'png' | 'jpeg' | 'webp'
}

export interface FileValidationResult {
  isValid: boolean
  error?: string
  fileSize?: number
  dimensions?: { width: number; height: number }
}

export const SUPPORTED_IMAGE_FORMATS = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'] as const
export const MAX_FILE_SIZE = 10 * 1024 * 1024
export const MAX_IMAGE_DIMENSION = 1000
export const DEFAULT_IMAGE_QUALITY = 0.9
export const CUSTOM_IMAGE_ID = 'custom-uploaded-image'

export type SupportedImageFormat = typeof SUPPORTED_IMAGE_FORMATS[number]